import { useNavigate } from 'react-router-dom';
import { makeVar } from '@apollo/client';

const bookmarkVar = makeVar('');

export type NavigationKeys =
  | 'REQUESTS'
  | 'BILLREQUEST'
  | 'SERVICES'
  | 'REQUEST';

const useCommonNavigations = () => {
  const navigate = useNavigate();

  const backToBookmark = (fallback?: NavigationKeys) => {
    if (bookmarkVar().length > 0) {
      navigate(bookmarkVar());
      bookmarkVar('');
    } else {
      if (fallback === 'BILLREQUEST') goToBillRequest();
      else if (fallback === 'SERVICES') goToServices();
      else if (fallback === 'REQUEST') goToAgentRequest();
      else goToRequests();
    }
  };

  const navigateTo = (path: string, bookmark?: string) => {
    if (bookmark) {
      bookmarkVar(bookmark);
    }
    navigate(path);
  };
  const goToRequests = (bookmark?: string) => {
    navigateTo('/requests', bookmark);
  };

  const goToBillRequest = (bookmark?: string) => {
    navigateTo('/billrequest', bookmark);
  };

  const goToCustomerBills = (
    serviceName: string,
    serviceId: string,
    customerId: string,
    bookmark?: string
  ) => {
    const billRequestPath = `/services/${serviceName}/${serviceId}/${customerId}`; //services/BillPay/1001/QA829294
    navigateTo(billRequestPath, bookmark);
  };

  const goToAgentRequest = (bookmark?: string) => {
    navigateTo('/request', bookmark);
  };

  const goToServices = (bookmark?: string) => {
    navigateTo('/services', bookmark);
  };

  const goToBillRepayment = () => {
    navigate('bill-repayment');
  };

  const goToTemplateReceipt = (
    receiptTemplate: string,
    uid: string,
    bookmark?: string
  ) => {
    navigateTo(`/receipt/${receiptTemplate}/${uid}`, bookmark);
  };

  const goToReceipt = (uid: string, bookmark?: string) => {
    goToTemplateReceipt('momobasic', uid, bookmark);
  };

  const goToRequest = (uid: string, bookmark?: string) => {
    navigateTo(`/request/${uid}`, bookmark);
  };

  const goToReverseFunds = (uid: string, bookmark?: string) => {
    navigateTo(`request/${uid}/funds/`, bookmark);
  };

  const goToReport = (reportId: string, bookmark?: string) => {
    navigateTo(`/reports/${reportId}`, bookmark);
  };

  const goToServiceIntakeForm = (
    serviceType: string,
    serviceId: number,
    bookmark?: string
  ) => {
    navigateTo(`/services/${serviceType}/${serviceId}`, bookmark);
  };

  const goHome = () => {
    navigate('/');
  };

  const goTo = (redirect: string, bookmark?: string) => {
    navigateTo(redirect);
  };

  const goBack = () => {
    navigate(-1);
  };

  const goToCustomers = (bookmark?: string) => {
    navigateTo('/customers', bookmark);
  };

  const goToCustomer = (customerId: string, bookmark?: string) => {
    navigateTo(`/customers/${customerId}`, bookmark);
  };

  return {
    goToRequests,
    goToBillRequest,
    goToReceipt,
    goToRequest,
    goBack,
    goToBillRepayment,
    goToCustomerBills,
    goToAgentRequest,
    goToReverseFunds,
    goToReport,
    goHome,
    goTo,
    goToCustomers,
    goToCustomer,
    backToBookmark,
    goToTemplateReceipt,
    goToServices,
    goToServiceIntakeForm,
  };
};

export default useCommonNavigations;
